import { makeStyles } from '@material-ui/core'

export default makeStyles((theme) => ({
  appBar: {
    boxShadow: 'none',
    background: 'transparent',
  },

  backdrop: {
    backgroundColor: 'transparent',
    backdropFilter: 'blur(3px)',
  },

  navbar: {
    padding: theme.spacing(0, 4),
    position: 'relative',
    height: 64,
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(0, 8),
    },
  },

  navbarMask: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: ({ isWindowOnTop, isOpen }) =>
      isWindowOnTop || isOpen ? 'transparent' : 'rgba(255, 255, 255, 0.90)',
    transition: 'all 0.5s ease-in-out',
    backdropFilter: 'blur(3px)',
    opacity: ({ isWindowOnTop }) => isWindowOnTop && 0,
  },

  logoContainer: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    zIndex: 999,
    opacity: ({ isWindowOnTop }) => isWindowOnTop && 0,
  },
  navLinks: {
    margin: theme.spacing(0),
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(4),
    display: 'block',
    width: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 10,
    listStyleType: 'none',
    transition: theme.transitions.default,
    overflow: 'hidden',
    backgroundColor: 'rgba(255, 255, 255, 0.90)',
    backdropFilter: 'blur(3px)',
    padding: theme.spacing(2, 4),
    borderBottomLeftRadius: theme.spacing(2),
    borderBottomRightRadius: theme.spacing(2),
    boxShadow: theme.shadows[6],
    '& a': {
      display: 'block',
      padding: theme.spacing(1),
      margin: theme.spacing(1.5, 0),
      textDecoration: 'none',
      textTransform: 'none',
      fontSize: theme.typography.body2.fontSize,
      color: theme.palette.text.disabled,
      transition: theme.transitions.default,
      fontWeight: theme.typography.fontWeightRegular,
      letterSpacing: theme.typography.letterSpacing,
    },

    [theme.breakpoints.up('md')]: {
      display: 'flex',
      height: 'auto',
      position: 'static',
      justifyContent: 'space-around',
      padding: theme.spacing(0, 4),
      margin: theme.spacing(0),
      borderRadius: 0,
      backgroundColor: 'transparent',
      boxShadow: 'none',
      '& a': {
        fontSize: theme.typography.body2.fontSize,
      },
      [theme.breakpoints.up('md')]: {
        textAlign: 'center',
        '& :hover': {
          color: theme.palette.secondary.main,
        },
      },
    },
  },

  animWrapper: {
    [theme.breakpoints.up('md')]: {
      opacity: '1 !important',
      height: 64,
    },
  },

  selectedNavLink: {
    '& a': {
      width: 100,
      color: theme.palette.text.main,
      fontWeight: theme.typography.fontWeightBold,
      borderBottom: `2px solid ${theme.palette.primary.main}`,
    },
  },
  logoBtn: {
    display: 'block',
    backgroundColor: 'transparent',
    border: 'none',
    outline: 'none',
    color: theme.palette.text.main,
    fontSize: theme.typography.body1.fontSize,
    zIndex: 999,
    opacity: ({ isWindowOnTop }) => isWindowOnTop && 0,
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },

  menuContainer: {
    opacity: ({ isWindowOnTop }) => isWindowOnTop && 0,
    transition: theme.transitions.default,
    display: 'flex',
    justifyContent: 'flex-end',
    [theme.breakpoints.up('md')]: {
      display: 'block',
    },
  },

  hidden: {
    transition: theme.transitions.default,
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
  },
}))
